// react
import { useContext, useEffect, useState } from "react";

// context
import ProductContext from "../../context/ProductContext";
import Shelf from "../shelf/shelf.component";

// styles
import "./cartItem.styles.scss";

const CartItem = () => {
  const context: any = useContext(ProductContext);

  const {
    productState: { SAPPricingInfo, ProductTitle, Quantity, MainImage },
  }: {
    productState: {
      SAPPricingInfo: any;
      ProductTitle: string;
      Quantity: number;
      MainImage: any;
    };
  } = context;

  const [totalPriceStr, setTotalPriceStr] = useState("");
  const [totalMSRPStr, setTotalMSRPStr] = useState("");

  const currencyConverter = (type: any, formatted: any) =>
    SAPPricingInfo?.RawPrice !== 0
      ? `${SAPPricingInfo?.Currency}${type?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })}`
      : formatted ?? "";

  const totalCalculator = (type: any) => (type ? type * (Quantity ?? 1) : 0);

  const quantityHandler = () => {
    const totalPrice = totalCalculator(SAPPricingInfo?.RawPrice);
    const totalMSRP = totalCalculator(SAPPricingInfo?.RawMSRP);

    const totalPriceStr: any = currencyConverter(
      totalPrice,
      SAPPricingInfo?.FormattedPrice,
    );

    setTotalPriceStr(totalPriceStr);

    const totalMSRPStr: any = currencyConverter(
      totalMSRP,
      SAPPricingInfo?.FormattedMSRP,
    );

    setTotalMSRPStr(totalMSRPStr);
  };

  useEffect(() => {
    quantityHandler();
    // eslint-disable-next-line
  }, [Quantity]);

  return (
    <div className="cartItem">
      <div className="cartItem-media">
        <div className="cartItem-media-img">
          <img src={MainImage?.Url} alt={`${MainImage?.Title}`} />
        </div>
      </div>
      <div className="cartItem-bd">
        <Shelf mobile="5" tablet="5" desktop="5">
          <span className="cartItem-bd-productTitle">{ProductTitle}</span>
        </Shelf>
        <Shelf mobile="5" tablet="5" desktop="5">
          <span className="cartItem-bd-sku">{`SKU: ${SAPPricingInfo?.ProductId}`}</span>
        </Shelf>
        <Shelf mobile="5" tablet="5" desktop="5">
          <span className="cartItem-bd-qty">{`Quantity: ${Quantity}`}</span>
        </Shelf>
        <Shelf mobile="0" tablet="0" desktop="0">
          <span className="cartItem-bd-totalPrice">{`${totalPriceStr} ${SAPPricingInfo?.CurrencyCode}`}</span>
        </Shelf>
        <Shelf mobile="0" tablet="0" desktop="0">
          <span className="cartItem-bd-totalMSRP">{`MSRP: ${totalMSRPStr}`}</span>
        </Shelf>
      </div>
    </div>
  );
};

export default CartItem;
